import React from "react";
import Classes from "./Footer.module.css";
import { scrollToElement } from "../../../utils/scrollToElement";
import { useLocation, useNavigate } from "react-router-dom";
import { FacebookCircleIcon, InstagramCircleIcon, LinkedInIcon, TwitterIcon } from "../../../utils/Icons";

export default function Footer() {
    const navigateTo = useNavigate();
    const location = useLocation();

    const handleScrollOrNavigate = (id, offset = 0) => {
        if (location.pathname !== '/') {
            navigateTo('/', { state: { scrollTo: { id, offset } } });
        } else {
            scrollToElement(id, offset);
        }
    };

    return (
        <footer className={`${Classes.footer} layoutPadding`}>
            <div className={Classes.topArea}>
                <div onClick={() => { navigateTo('/') }} className={Classes.logo} style={{ display: 'block', height: '2rem', width: 'fit-content', cursor: 'pointer' }} >
                    <img src="/assets/images/logo.png" style={{ height: '100%' }} draggable={false} />
                </div>
                <div className={Classes.navColumns}>
                    <div>
                        <h4>Quick Links</h4>
                        <ul>
                            <li> <h5 onClick={() => { handleScrollOrNavigate('home', 0) }} > Home </h5> </li>
                            <li> <h5 onClick={() => { handleScrollOrNavigate('features', 20) }} > Features </h5> </li>
                            <li> <h5 onClick={() => { handleScrollOrNavigate('pricing', 20) }} > Pricing </h5> </li>
                            <li> <h5 onClick={() => { navigateTo('/manufacturers') }} > Manufacturers </h5> </li>
                        </ul>
                    </div>
                    <div className={Classes.alignCenter} >
                        <h4>Support & Contact</h4>
                        <ul>
                            <li onClick={() => { navigateTo('/contact-us') }} > <h5>Contact Us</h5> </li>
                            <li> <h5 onClick={() => { handleScrollOrNavigate('faq', -50) }} >FAQ</h5> </li>
                        </ul>
                    </div>
                    <div className={Classes.alignEnd} >
                        <h4>Connect</h4>
                        <ul>
                            <li> <a href="https://www.evolvion.io/" target='_blank' > <FacebookCircleIcon height={20} fill='#747474' /> <h5>Facebook</h5> </a> </li>
                            <li> <a href="https://www.evolvion.io/" target='_blank' > <InstagramCircleIcon height={20} fill='#747474' /> <h5>Instagram</h5> </a> </li>
                            <li> <a href="https://www.evolvion.io/" target='_blank' > <TwitterIcon height={20} fill='#747474' /> <h5>Twitter / X</h5> </a> </li>
                            <li> <a href="https://www.evolvion.io/" target='_blank' > <LinkedInIcon height={20} fill='#747474' /> <h5>LinkedIn</h5> </a> </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Divider line */}
            <div className={Classes.divider}></div>

            {/* Bottom bar: copyright + social */}
            <div className={Classes.bottomBar}>
                <span><h5>©2025 LightTrack · All rights reserved.</h5></span>
                <div className={Classes.policiesCon} >
                    <a href="/data-security" target='_blank' > <h5>Data Security</h5> </a>
                    <a href="/terms-of-service" target='_blank' > <h5>Terms of Service</h5> </a>
                    <a href="/privacy-policy" target='_blank' > <h5>Privacy Policy</h5> </a>
                </div>
            </div>
            <div className={Classes.developedBy} >
                <h5> Developed by <a target="_blank" href="https://www.evolvion.io/" > Evolvion </a> </h5>
            </div>
        </footer>
    );
}
